import type React from 'react';
import { useEffect, useState } from 'react';

import { useParams } from 'js/lib/useRouter';

import { isDegreeHomeV2Enabled } from 'bundles/degree-home/utils/experimentUtils';

import { degreeV3ShouldBeShown } from './v3-dpm/lib/experiments';

type InputProps = {
  v1: React.ReactElement;
  v2: React.ReactElement;
  v3: React.ReactElement | null;
};

type DegreeExperience = 'v1' | 'v2' | 'v3';

const DegreeHomeV2BranchWrapper: React.FunctionComponent<InputProps> = ({ v1, v2, v3 }) => {
  const { degreeSlug } = useParams();

  const [componentDidMount, setComponentDidMount] = useState(false);
  const [degreeExperience, setDegreeExperience] = useState<DegreeExperience>('v1');

  useEffect(() => {
    if (degreeSlug && degreeV3ShouldBeShown(degreeSlug)) {
      setDegreeExperience('v3');
    } else if (isDegreeHomeV2Enabled(degreeSlug)) {
      setDegreeExperience('v2');
    } else {
      setDegreeExperience('v1');
    }
    setComponentDidMount(true);
  }, [degreeSlug]);

  if (!componentDidMount) {
    return null;
  }

  switch (degreeExperience) {
    case 'v3':
      return v3;
    case 'v2':
      return v2;
    default:
      return v1;
  }
};

export default DegreeHomeV2BranchWrapper;
